<template>
  <p style="padding: 30px;">
    In terms of the identity verification process for the purpose of &lt;put client's use case here:your personal data in the form of demoaraphic and/or biometric data will be checked forconformity, by PT Indonesia Digital ldentity (VIDA) as our partner, with data recorded in thesvstem of the governracencv authorised to issue the relevant identity if voupersonadata is verified for conformity. then VIDA as the Certification Authority certified by the Ministrof Communication and lnformatics, will issue a digital certificate as evidence that youipersonal data has been verified and is in accordance with the data recorded in the svstem ofthe government agency authorised to issue the identity.
    Therefore, vou quarantee the accuracy of the personal data vou provide and agree to theprocessing of your personal data for the purpose of issuing digital certificates and otherservices attached to diaital certificates performed by VIDA.
    You have read, understood, and agreed to be bound by the terms and conditions of theCertification Authority's service contained in the Subscriber Agreement, CA Privacy Policyand VIDA's Certification Practice Statement which can be accessed via
    <a href="https://repo.vida.id" target="_blank">https://repo.vida.id</a>.
  </p>
</template>

<script>
export default {
  name: 'Vida'
}
</script>

<style scoped>

</style>
